export default "__VITE_ASSET__b604eceb__"